import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { ReplaceQuoteInput, ReplaceQuotePayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = ReplaceQuoteInput;
type TData = ReplaceQuotePayload;

export const useTranslationRequestReplaceQuote = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation translationRequestReplaceQuote($input: ReplaceQuoteInput!) {
      translationRequestReplaceQuote(input: $input) {
        success
        errors
        errorCode
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
